import React from 'react';
import './HomePage.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import icon1 from '../../img/icon1.png';
import icon2 from '../../img/icon2.png';
import icon3 from '../../img/icon3.png';
import icon4 from '../../img/icon4.png';

const HomePage = ({ scrollToSolutions }) => {
  return (
    <div className="ran-homepage">
      <div className="ran-content text-center">
        <h1 className="ran-main-title">
          <span className="gradient-text">RAN GLOBAL AUTO</span> ENGG PVT. LTD.
        </h1>
        <p className="ran-tagline">
          Forging the Future of Automotive Excellence for <strong>32 Years</strong>.
        </p>
        <p className="ran-tagline">
          Delivering precision-engineered stamped auto components, built on decades of expertise and a commitment to quality.
        </p>
        <button className="ran-cta-btn" onClick={scrollToSolutions}>
          Explore Our Capabilities
        </button>
      </div>

      {/* Floating Icons */}
      <img src={icon1} alt="Icon 1" className="floating-icon icon-1" />
      <img src={icon2} alt="Icon 2" className="floating-icon icon-2" />
      <img src={icon3} alt="Icon 3" className="floating-icon icon-3" />
      <img src={icon4} alt="Icon 4" className="floating-icon icon-4" />
    </div>
  );
};

export default HomePage;
